import { gql } from '@apollo/client';

export const CREATE_PAGE_TEMPLATE = gql`
  mutation createPageTemplate($data: CreatePageTemplateInput!) {
    createPageTemplate(data: $data) {
      message
      page {
        id
        title
        type
        isTemplate
        status
        createdAt
      }
    }
  }
`;

export const UPDATE_PAGE_TEMPLATE = gql`
  mutation updatePageTemplate(
    $where: PageUniqueInput!
    $data: UpdatePageTemplateInput!
  ) {
    updatePageTemplate(where: $where, data: $data) {
      message
      page {
        id
        title
        templateName
        updatedAt
      }
    }
  }
`;

export const DELETE_PAGE_TEMPLATE = gql`
  mutation deletePageTemplate($where: PageUniqueInput!) {
    deletePageTemplate(where: $where) {
      message
    }
  }
`;

export const UPDATE_PAGE_TEMPLATE_STATUS = gql`
  mutation updatePageStatus($id: ID!, $status: PageStatus!) {
    updatePageStatus(where: { id: $id }, data: { status: $status }) {
      message
    }
  }
`;
